'use client'
import {
  CARD_QUERY
} from "./chunk-O222NDDR.mjs";
import {
  TAG_QUERY
} from "./chunk-MWW3YBFP.mjs";
import {
  AUCTION_LIST_QUERY
} from "./chunk-NPNDRLDV.mjs";
import {
  EVENT_LIST_QUERY
} from "./chunk-E577PGQH.mjs";
import {
  LOCATION_QUERY
} from "./chunk-RJD7S7WV.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-5GNKV3HD.mjs";
import {
  LINK_QUERY
} from "./chunk-Y5YNZ765.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/page.ts
var PAGE_SECTION_QUERY = `
... on WebSection {
    id
    title
    subtitle
    collapsableDescription{json}
    renderType
    itemRenderType
    backgroundColor
    topPadding
    bottomPadding
    sectionBackground {${IMAGE_QUERY}}
    logo {${IMAGE_QUERY}}
    topDecorator {${IMAGE_QUERY}}
    bottomDecorator {${IMAGE_QUERY}}
    utm
    platform
    organizationSlug
    teamId
    webLinksCollection(limit: 6){
        items{${LINK_QUERY}}
    }
    theme {
      primary
      secondary
      tertiary
      action
      textPrimary
      body
    }
    tagsCollection(limit: 10){
        items {${TAG_QUERY}}
    }
    contentCollection(limit: 30) {
        items {
            __typename
            ... on Zone {
                id
                slug
                title
                subtitle
                description
                featuredBanner {${IMAGE_QUERY}}
                banner {${IMAGE_QUERY}}
                zoneLogo {${IMAGE_QUERY}}
                sponsorLogo {${IMAGE_QUERY}}
                imageBg {${IMAGE_QUERY}}
                schedule {${SCHEDULE_QUERY}}
                location{${LOCATION_QUERY}}
                button { label link }
                startingPrice
                currencyCode
                newZone
            }
            ... on Event {${`${EVENT_LIST_QUERY} isStreamingEvent buyLiveStream{id} eventLogo{${IMAGE_QUERY}} streamingMessage showResellBanner`}}
            ... on WebCard {${CARD_QUERY}}
            ... on Experience {${EVENT_LIST_QUERY} discountedPrice}
            ... on Restaurant {${EVENT_LIST_QUERY} cuisine}
            ... on Package {${EVENT_LIST_QUERY}}
            ... on Auction {${AUCTION_LIST_QUERY}}
            ... on Category { id slug title icon {${IMAGE_QUERY}} background {${IMAGE_QUERY}} isNew }
            ... on Tag { id slug title icon {${IMAGE_QUERY}} background {${IMAGE_QUERY}} isNew }
            ... on SocialBanner {
                id
                title
                logoImage {${IMAGE_QUERY}}
                socialLinks {
                    id
                    title
                    iconLinksCollection(limit: 6) {
                        items {${LINK_QUERY}}
                    }
                }
            }
            ... on SponsorList {
                id
                title
                sponsorsCollection(limit: 12) {
                    items {
                        id
                        title
                        logo {${IMAGE_QUERY}}
                        link
                    }
                }
            }
        }
    }
}
`;

export {
  PAGE_SECTION_QUERY
};
//# sourceMappingURL=chunk-46Z5IX3R.mjs.map